import { render, staticRenderFns } from "./DeliveryTimeConfiguration.vue?vue&type=template&id=7d5331d4&scoped=true"
import script from "./DeliveryTimeConfiguration.vue?vue&type=script&lang=js"
export * from "./DeliveryTimeConfiguration.vue?vue&type=script&lang=js"
import style0 from "./DeliveryTimeConfiguration.vue?vue&type=style&index=0&id=7d5331d4&prod&lang=less&scoped=true"
import style1 from "./DeliveryTimeConfiguration.vue?vue&type=style&index=1&id=7d5331d4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d5331d4",
  null
  
)

export default component.exports